import type {
    SheetMaxWidthConstantType,
    SheetCompactBehaviour,
    SheetFormConstantType,
    SheetEdgeType,
    SheetFormType,
    SheetSide,
    SheetSize
} from "./type";

export const SHEET_EDGES: Record<SheetSide, SheetEdgeType> = {
    bottom: "bottom",
    start: "start",
    left: "start",
    right: "end",
    top: "top",
    end: "end"
};

export const SHEET_COMPACT_BEHAVIOURS: Record<SheetEdgeType, SheetCompactBehaviour> = {
    bottom: "keepSide",
    top: "bottomSheet",
    start: "keepSide",
    end: "bottomSheet"
};

export const SHEET_SIZE_SCALES: Record<SheetSize, number> = {
    large: 1.5,
    medium: 1
};

export const SHEET_INITIAL_FOCUS_ATTEMPTS = 30;

export const getSheetEdge = ({
    side
}: {
    side: SheetSide;
}): SheetEdgeType => SHEET_EDGES[side];

export const getSheetForm = ({
    compactBehaviour,
    breakpoint,
    isModal,
    edge
}: SheetFormConstantType): SheetFormType => {
    if(edge === "bottom") {
        return "bottom";
    }

    if(!isModal || breakpoint !== "compact") {
        return "panel";
    }

    const behaviour = compactBehaviour ?? SHEET_COMPACT_BEHAVIOURS[edge];

    return behaviour === "bottomSheet" ? "bottom" : "panel";
};

export const getSheetMaxWidth = ({
    shapeConfigs,
    width,
    size
}: SheetMaxWidthConstantType): number => width ?? shapeConfigs.dialogMaxWidth * SHEET_SIZE_SCALES[size];
